import { GlobalDataLayerService } from './global-data-layer-service';
import { EventActions } from '../../utility/constants';

export function sendDataLayerEventShoppingCart(elementId: string, elementName: string, url?: string) {
  GlobalDataLayerService.getInstance().pushDataLayerEvent(EventActions.CONTEXTUAL_BUTTON_CLICK, {
    componentClick: {
      clickElementId: elementId,
      clickElementName: elementName,
      ...(url && { targetUrl: url })
    }
  });
}
